import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./TaxInfoForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelSetTaxInfo} from "../../actions/AccountApiActions";
import {fromJS, Map} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {isEurope} from "../../lib/ShopHelper";

function validateForm(values, props) {
  let errors = Map();
  return errors.toJS();
}

class SetTaxInfoFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      accountId: this.props.accountId,
      taxId: values.get("taxId", ""),
      validateTaxId: values.get("validateTaxId")
    }

    return this.props.assignTaxId(updatedValues)
      .then((response) => {
        if (response.data.assignTaxId.errors.length <= 0) {
          this.props.cancelSetTaxInfo();
        } else {
          let errors = createValidationErrors(response.data.assignTaxId.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelSetTaxInfo();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let account = fromJS(data.billingAccount)
    let initialValues = {
      taxId: account.get("taxId", ""),
      validateTaxId: account.get("validTaxId")
    }
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        showValidateTaxId={isEurope(account.get("shopId"))}
        />
    )
  }
}


const GET_BILLING_ADDRESS = gql`
  query billingAccount($accountId: ID!) {
    billingAccount(accountId: $accountId) {
      shopId
      taxId
      validTaxId
    }
  }
`;

const ASSIGN_TAX_ID = gql`
  mutation assignTaxId($data: BillingTaxInput!) {
    assignTaxId(input: $data) {
      errors { key message }
    }
  }
`;


const withQueries = compose(
  graphql(GET_BILLING_ADDRESS, {
    options: (props) => ({
      fetchPolicy: "network-only"
    })
  }),
  graphql(ASSIGN_TAX_ID, {
    props: ({ mutate }) => ({
      assignTaxId: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);


export default connect(null, {cancelSetTaxInfo})(withQueries(SetTaxInfoFormContainer));

